import logo from "../../assets/footer-logo.svg";

const Botfooter = () => {
    return (
        <footer>
            <div className="container">
                <img src={logo} alt=""/>
                <div className="">
                    {"© 2021 Rap Scene , LLC. All rights reserved."}
                </div>
            </div>
        </footer>
    );
}
 
export default Botfooter;